<template>
  <v-container class="admin-function mx-2" fluid>
    <div class="admin-function__header">
      <div class="admin-function__header-left">
        <v-icon color="primary" class="admin-function__header-icon">mdi-cog-outline</v-icon>
        <h1 class="admin-function__title">Раздел администрирования</h1>
      </div>
      <v-btn
        color="primary"
        outlined
        rounded
        class="text-none"
        @click="returnDoorphones"
      >
        <v-icon left small>mdi-doorbell-video</v-icon>
        Домофоны
      </v-btn>
    </div>
    <v-card class="admin-function__card" flat outlined>
      <v-tabs class="admin-function__tabs" show-arrows="mobile">
        <template v-for="tab in filterTabs()">
          <v-tab
            v-if="tab.show"
            :key="tab.name"
            class="admin-function__tab"
          >
            <v-icon v-if="tab.icon" left small class="admin-function__tab-icon">{{ tab.icon }}</v-icon>
            {{ tab.name }}
          </v-tab>
          <v-tab-item
            v-if="tab.show"
            :key="tab.name"
            class="admin-function__tab-item"
          >
            <component :is="tab.component" />
          </v-tab-item>
        </template>
      </v-tabs>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditMailNotification from '@/components/adminSettings/EditMailNotification';
import DoorphoneTestActivation from '@/components/adminSettings/DoorphoneTestActivation';
import ApartmentPayment from '@/components/adminSettings/ApartmentPayment';
import SipPasswordApartment from '@/components/adminSettings/SipPasswordApartment';
import GettingLogData from '@/components/adminSettings/GettingLogData';
import AgentChange from '@/components/adminSettings/AgentChange';
import HomePageSettings from '@/components/adminSettings/HomePageSettings';
import LkNotificationsAdmin from '@/components/adminSettings/LkNotificationsAdmin';

export default {
  name: 'AdminFunction',
  data () {
    return {
      dataMail: [],
    };
  },
  created () {},
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphone',
    }),
    tabs () {
      return [
        {
          name: 'Активация домофона',
          icon: 'mdi-cellphone-check',
          component: DoorphoneTestActivation,
          route: 'DoorphoneActivation',
          show: true,
        },
        {
          name: 'Оплата квартир',
          icon: 'mdi-credit-card-outline',
          component: ApartmentPayment,
          route: 'ApartmentPayment',
          show: true,
        },
        {
          name: 'Смена агента',
          icon: 'mdi-account-switch-outline',
          component: AgentChange,
          route: 'AgentChange',
          show: true,
        },
        {
          name: 'SIP пароль и статистика',
          icon: 'mdi-key-variant',
          component: SipPasswordApartment,
          route: 'SipPasswordApartment',
          show: true,
        },
        {
          name: 'Получение данных (логи)',
          icon: 'mdi-file-document-outline',
          component: GettingLogData,
          route: 'GettingLogData',
          show: true,
        },
        {
          name: 'Почта',
          icon: 'mdi-email-outline',
          component: EditMailNotification,
          route: 'EditMailNotification',
          show: true,
        },
        {
          name: 'Настройка главной страницы',
          icon: 'mdi-home-cog-outline',
          component: HomePageSettings,
          route: 'HomePageSettings',
          show: true,
        },
        {
          name: 'Уведомления ЛК',
          icon: 'mdi-bell-plus-outline',
          component: LkNotificationsAdmin,
          route: 'LkNotificationsAdmin',
          show: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      getTempCodeMail: 'AdminSettings/getTempCodeMail',
    }),
    returnDoorphones () {
      this.$router.push({ name: 'Doorphone' });
    },
    filterTabs () {
      return this.tabs.filter(tab => this.$canRoute(tab.route));
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-function__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.admin-function__header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.admin-function__header-icon {
  flex-shrink: 0;
}

.admin-function__title {
  font-size: 1.5rem;
  font-weight: 500;
  color: #37474f;
  margin: 0;
  letter-spacing: -0.01em;
}

.admin-function__card {
  border-radius: 12px;
  overflow: hidden;
}

.admin-function__tabs {
  flex: 1;
}

.admin-function__tab-item {
  padding: 20px 24px;
}

@media screen and (max-width: 600px) {
  .admin-function__header {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
